/* eslint-disable */
import React, { Component } from "react";
import Chart from "react-apexcharts";
import {
    Box,
    Card,
    CardContent,
    Divider,
    Tooltip,
    IconButton,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Grid,
    Typography,
    withStyles,
    Icon,
} from '@material-ui/core';
import { useStyles } from '../../style';
import roundWorkHistory from '../../../../../assets/icons/capitalTrabajoCicloIcon.svg';
import es from "../../../../../assets/languagePackages/es.json";

export default function ChartCapitalTrabajoCicloEfectivo({ data }) {
    console.log("datautilidades", data)
    const classes = useStyles();

    const chartData = {
        options: {
            chart: {
                locales: [es],
                fontFamily: 'Roboto, sans-serif',
                defaultLocale: 'es',
                type: 'line',
                stacked: false,
                id: "basic-bar",
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 7,
                    left: 2,
                    blur: 7,
                    opacity: 0.2
                },
                toolbar: {
                    show: true
                },
            },
            plotOptions: {
                bar: {
                    colors: {
                        ranges: [
                            {
                                from: -Number.MAX_VALUE,
                                to: 0,
                                color: '#fac004' // Color para valores negativos
                            },
                            {
                                from: 0,
                                to: Number.MAX_VALUE,
                                color: '#024788' // Color para valores positivos
                            }
                        ]
                    },
                    columnWidth: '50%',
                }
            },
            stroke: {
                width: [0, 2]
            },
            xaxis: {
                type: 'datetime',
            },
            yaxis: [
                {
                    axisTicks: {
                        show: true,
                    },
                    axisBorder: {
                        show: true,
                        color: '#024787'
                    },
                    labels: {
                        style: {
                            colors: '#024787',
                        },
                        formatter: function (y) {
                            const formattedValue = y.toLocaleString(undefined, {
                                style: 'currency',
                                currency: 'USD',
                            });
                            return formattedValue;
                        }
                    },
                    title: {
                        text: "Capital de trabajo",
                        style: {
                            color: '#024787',
                        }
                    },
                },
                {
                    seriesName: 'Capital de trabajo',
                    opposite: true,
                    axisTicks: {
                        show: true,
                    },
                    axisBorder: {
                        show: true,
                        color: '#6AA8C7'
                    },
                    labels: {
                        style: {
                            colors: '#6AA8C7',
                        },
                        formatter: function (y) {
                            
                            return `${y} dias`;
                        }
                    },
                    title: {
                        text: "Ciclo de conversión de efectivo",
                        style: {
                            color: '#6AA8C7',
                        }
                    }
                },
            ],
            tooltip: {
                enabled: true,
                style: {
                    fontFamily: 'Roboto, "sans-serif"',
                },
                intersect: false,
                
            },
            legend: {
                horizontalAlign: 'left',
                offsetX: 40
            },
            colors: ['#024788','#6AA8C7']
        },
        series: [{
            name: 'Capital de Trabajo',
            type: 'column',
            data: data.capitalTrabajo
        },
            {
                name: 'Ciclo de Conversion de Efectivo',
                type: 'line',
                data: data.conversionEfectivo
            }
        ]
    }

    console.log("chartdata", chartData)


    return (

        <Grid component={Card} padding={3}>
            <Grid className={classes.chartLineBarsBox} item xs={12} md={12}>
                <div>
                    <img src={roundWorkHistory} alt="roundWorkHistory" width="35px" height="35px"/>
                </div>
                <Typography className={classes.chartBarDonutText} paddingLeft={2}>
                    Capital de Trabajo y Ciclo de Conversión de Efectivo
                </Typography>
            </Grid>
            <Grid item xs={12} md={12} height={300} width="100%">
                <Chart
                    options={chartData.options}
                    series={chartData.series}
                    type="line"
                    width="100%"
                    height="100%"
                />
            </Grid>

        </Grid>


    );
}